@if (form) {
  <form [formGroup]="form" novalidate>
    <!-- Header -->
    <div class="modal-header">
      <!-- Title -->
      <h6 class="modal-title" i18n="@@components.add_mdm_config_modal.title">Add Master Data Mapping</h6>
      <!-- Title end -->
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <!-- Header end -->
    <!-- Content -->
    <div class="modal-body">
      <div>
        <div class="row max-form-width">
          <div class="col-sm-6">
            <radio-field formControlName="search_mode" value="simple" i18n-label="@@components.add_mdm_config_modal.search_mode_simple" label="Simple" i18n-description="@@components.add_mdm_config_modal.search_mode_simple_description" description="This mode is more performant on large database tables. It works with one search term on multiple table columns."></radio-field>
          </div>
          <div class="col-sm-6">
            <radio-field formControlName="search_mode" value="advanced" i18n-label="@@components.add_mdm_config_modal.search_mode_advanced" label="Advanced" i18n-description="@@components.add_mdm_config_modal.search_mode_advanced_description" description="This mode performs better on smaller database tables. It searches with multiple terms (whitespace-separated) on multiple table columns."></radio-field>
          </div>
          <div class="col-sm-6">
            <input-field formControlName="name" i18n-label="@@components.add_mdm_config_modal.name" label="Name"></input-field>
          </div>
          <div class="col-sm-6">
            <select-field formControlName="table_name" i18n-label="@@components.add_mdm_config_modal.table_name" label="Table" [options]="tableNameOptions"></select-field>
          </div>
          @if (tableColumns.length > 0) {
            <div formGroupName="field_mapping">
              <div class="col-sm-12">
                <div class="row mb-2">
                  <div class="col-sm-6">
                    <div class="row">
                      <div class="col-sm-5 bold" i18n="@@components.add_mdm_config_modal.table_column">Table Column</div>
                      <div class="col-sm-4 bold"i18n="@@common.type">Type</div>
                      @if (form.get('search_mode').value === 'advanced') {
                        <div class="col-sm-3 bold" i18n="@@components.add_mdm_config_modal.search_only">Search Only</div>
                      }
                    </div>
                  </div>
                  <div class="col-sm-6 bold" i18n="@@components.add_mdm_config_modal.write_to_document_type_field">Write to Document-Type-Field</div>
                </div>
                @for (column of tableColumns; track column) {
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="row">
                        <div class="col-sm-5"> {{ column.name }}</div>
                        <div class="col-sm-4">{{ column.type }}</div>
                        @if (form.get('search_mode').value === 'advanced') {
                          <div class="col-sm-3">
                            <checkbox-field [formControlName]="'search_only_' + column.name" label=""></checkbox-field>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <typeahead-field
                        [formControlName]="column.name"
                        label=""
                        type="string"
                        labelProp="label"
                        valueProp="value"
                        icon="pen-field"
                        [search]="searchFields"
                        [translateInitialValueToLabel]="translateInitialFieldValueToLabel"
                        [optionsLimit]="10"
                        [minLength]="0"
                        [isFirstItemActive]="true"
                      ></typeahead-field>
                    </div>
                  </div>
                }
                @if (form.get('field_mapping').hasError('empty-field-mapping') && (form.get('field_mapping').touched || form.get('field_mapping').dirty)) {
                  <div class="row">
                    <div class="col-sm-12 danger text-end" i18n="@@components.add_mdm_config_modal.empty_field_mapping_error">
                At least one field mapping is required.
              </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <!-- Content end -->
    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" class="button-secondary-outlined" style="margin-right: 8px" (click)="cancel()" i18n="@@common.cancel">Cancel</button>
      <button type="button" class="button-secondary" (click)="confirm()"><span i18n="@@common.save">Save</span></button>
    </div>
    <!-- Footer end -->
  </form>
} @else {
  <div class="w-100 h-100 d-flex align-items-center justify-content-center">
    <fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
  </div>
}

